<!--
=========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
-->

<template>
  <div
    class="layout--main"
    :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]"
  >

    <v-nav-menu
      :navMenuItems="navMenuItems"
      title="Febos"
      parent=".layout--main"
    />
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">

      <div id="content-overlay"/>
      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                   class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{
                    // eslint-disable-next-line max-len
                    'pr-4 border-0 md:border-r border-solid border-grey-light': $route.meta.breadcrumb
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather"/>

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <router-link to="/pages/profile" class="flex items-center">
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/todo" class="flex items-center">
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/email" class="flex items-center">
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </router-link>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top
                bottom="2%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]"
        />
        <div style="height: 62px" v-if="navbarType === 'static'"/>
        <h-nav-menu
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]"
          :navMenuItems="navMenuItems"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]"
        />
      </template>
      <!-- /Navbar -->
      <the-footer :ambiente="ambiente" :version="version" :footer="footer"/>
    </div>
    <keyboard-event></keyboard-event>

  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import {mapGetters, mapState} from 'vuex';

import config from '../../package.json';
import themeConfig from '../../themeConfig';

import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu';
// import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal';
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical';
import TheFooter from '@/layouts/components/TheFooter';
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu';
import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import KeyboardEvent from '@/febos/global/_vue/componentes/devOpHelpers/DeveloperMode';

export default {
  mixins: [I18nMixin, PersonalizacionMixin],
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    KeyboardEvent
  },
  data() {
    return {
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      // navMenuItems      : navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    // eslint-disable-next-line func-names
    '$store.state.mainLayoutType': function (val) {
      this.setNavMenuVisibility(val);
    }
  },
  computed: {
    ...mapGetters('Empresas', ['empresaActual']),
    ...mapGetters('Usuario', ['usuarioActual']),
    ...mapState('Personalizacion', {
      colorNavbar: (state) => state.colores.navbar,
      footer: (state) => state.general.footer
    }),
    ...mapState('Menus', {
      navMenuItems: (state) => state.menus
    }),
    ambiente() {
      return process.env.VUE_APP_AMBIENTE;
    },
    version() {
      // console.log('version',config);
      return config.version;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced';
        if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg';
        return 'content-area-full';
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme === 'dark';
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    enableChatlio() {
      if (this.ambiente.toLowerCase() === 'produccion') {
        return true;
      }
      const dominio = window.location.hostname.toLowerCase();
      if (dominio.includes('machali')) {
        return true;
      }
      return false;
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      this.isNavbarDark = val !== '#fff';
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    },
    initChatlio() {
      if (!this.enableChatlio) {
        return;
      }

      window._chatlio = window._chatlio || [];
      const widget = document.getElementById('chatlio-widget-embed');
      if (widget && window.ChatlioReact && _chatlio.init) {
        return;
      }
      for (let e = function (t) {
        return function () {
          _chatlio.push([t].concat(arguments));
        };
      }, i = [
        'configure',
        'identify',
        'track',
        'show',
        'hide',
        'isShown',
        'isOnline',
        'page',
        'open',
        'showOrHide'
      ], a = 0; a < i.length; a++) {
        _chatlio[i[a]] || (_chatlio[i[a]] = e(i[a]));
      }
      const script = document.createElement('script');
      const
        script_node = document.getElementsByTagName('script')[0];
      script.id = 'chatlio-widget-embed',
        script.src = 'https://w.chatlio.com/w.chatlio-widget.js',
        script.async = !0,
        script.setAttribute('data-embed-version', '2.3');
      script.setAttribute('data-widget-id', '8e1aedc0-ce71-4e3a-4a73-f0edc4ab4294');
      script_node.parentNode.insertBefore(script, script_node);
      _chatlio.identify(
        this.usuarioActual.id, {
          name: this.usuarioActual.nombre,
          email: this.usuarioActual.correo,
          rut: this.usuarioActual.iut,
          rutEmpresa: this.empresaActual.iut,
          empresa: this.empresaActual.razonSocial,
          empresaID: this.empresaActual.id
        }
      );
    }
  },
  created() {
    this.updateNavbarColor(this.colorNavbar);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
    this.initChatlio();
  }
};

</script>
<style lang="scss">
/* CSS para el datetime, global */
.vdatetime {
  display: inline-block;
}

.vdatetime-popup__header,
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected > span > span:hover {
  background: rgba(var(--vs-primary));
}

.vdatetime-popup__actions__button,
.vdatetime-year-picker__item--selected,
.vdatetime-month-picker__item--selected {
  color: rgba(var(--vs-primary));
}

/* fin css para datetime */

#chatlio-widget .chatlio-title-bar {
  background-color: rgba(var(--vs-primary), 1) !important;
}

@media only screen and (max-width: 480px) {
  .chatlio-widget .chatlio-title-bar.chatlio-title-bar, .chatlio-widget .chatlio-title-bar.chatlio-title-bar-chip {
    width: 50px !important;
    height: 50px !important;
  }
}
</style>
